//https://www.apollographql.com/docs/react/essentials/mutations.html
import { gql } from "apollo-boost";

export const getCategoryManagementListQuery = gql`
  query($offset: Int, $pageNo: Int, $id: Int, $name: String, $status: Int) {
    getListOfCategories(
      noOfRows: $offset
      pageNumber: $pageNo
      id: $id
      name: $name
      status: $status
    ) {
      id
      name
      description
      manager
      client
      projectId
      displayOrder
      status
      viewByAllUsers
      statusDetail {
        name
      }
    }
  }
`;

export const getCategoryById = gql`
  query($id: Int!) {
    getCategoryById(id: $id) {
      id
      name
      description
      displayOrder
      status
      viewByAllUsers
      manager
      client
      projectId
      createdBy {
        loginId
      }
      createdOn
      lastModifiedBy {
        loginId
      }
      lastModifiedOn
    }
  }
`;

export const getCategoryByIdForProjectFolder = gql`
  query($id: Int!) {
    getCategoryByIdForProjectFolder(id: $id) {
      id
      name
      description
      displayOrder
      status
      viewByAllUsers
      manager
      client
      projectId
      createdBy {
        loginId
      }
      createdOn
      lastModifiedBy {
        loginId
      }
      lastModifiedOn
    }
  }
`;

export const createCategory = gql`
  mutation(
    $name: String!
    $displayOrder: Int!
    $description: String!
    $manager: String!
    $client: String!
    $projectId: String!
  ) {
    createCategory(
      data: {
        name: $name
        displayOrder: $displayOrder
        description: $description
        manager: $manager
        client: $client
        projectId: $projectId
      }
    ) {
      category {
        id
      }
    }
  }
`;

export const updateCategory = gql`
  mutation(
    $id: Int!
    $name: String!
    $description: String!
    $manager: String!
    $client: String!
    $projectId: String!
    $displayOrder: Int!
    $viewByAllUsers: Boolean!
    $status: Int!
  ) {
    updateCategory(
      id: $id
      data: {
        name: $name
        description: $description
        displayOrder: $displayOrder
        viewByAllUsers: $viewByAllUsers
        status: $status
        manager: $manager
        client: $client
        projectId: $projectId
      }
    ) {
      message
    }
  }
`;

export const getListOfCategoriesForTreeView = gql`
  {
    getListOfCategoriesForTreeView
  }
`;

export const getListOfCategoriesForDocUploadUserQuery = gql`
  query($offset: Int, $pageNo: Int, $id: Int, $name: String) {
    getListOfCategoriesForDocUploadUser(
      noOfRows: $offset
      pageNumber: $pageNo
      id: $id
      name: $name
    ) {
      id
      name
      description
      projectId
      displayOrder
      status
      viewByAllUsers
    }
  }
`;

export const getListOfCategoriesForCategoryViewUserQuery = gql`
  query($offset: Int, $pageNo: Int, $id: Int, $name: String) {
    getListOfCategoriesForCategoryViewUser(
      noOfRows: $offset
      pageNumber: $pageNo
      id: $id
      name: $name
    ) {
      id
      name
      description
      projectId
      displayOrder
      status
      viewByAllUsers
    }
  }
`;

export const addDocUploadUser = gql`
  mutation($userId: [Int]!, $categoryId: Int!) {
    addDocumentUploadUsers(data: { userId: $userId, categoryId: $categoryId }) {
      documentuploadusers {
        id
      }
    }
  }
`;

export const getDocUploadUsersListQuery = gql`
  query($referenceId: Int!) {
    getListOfDocumentUploadUsersByCategoryId(referenceId: $referenceId) {
      id
      userId {
        loginId
      }
      userDetail {
        name
      }
    }
  }
`;

export const removeDocUploadUser = gql`
  mutation($id: String!) {
    removeDocumentUploadUsers(id: $id) {
      message
    }
  }
`;

export const addDocViewUser = gql`
  mutation($userId: [Int]!, $categoryId: Int!) {
    addCategoryViewUsers(data: { userId: $userId, categoryId: $categoryId }) {
      categoryviewusers {
        id
      }
    }
  }
`;

export const getDocViewUsersListQuery = gql`
  query($referenceId: Int!) {
    getListOfCategoryViewUsersByCategoryId(referenceId: $referenceId) {
      id
      userId {
        loginId
      }
      userDetail {
        name
      }
    }
  }
`;

export const removeDocViewUser = gql`
  mutation($id: String!) {
    removeCategoryViewUsers(id: $id) {
      message
    }
  }
`;

export const createSubcategory = gql`
  mutation(
    $name: String!
    $description: String!
    $referenceId: Int
    $categoryId: Int!
    $subcategoryLevel: Int!
  ) {
    createSubCategory(
      data: {
        name: $name
        description: $description
        referenceId: $referenceId
        categoryId: $categoryId
        subcategoryLevel: $subcategoryLevel
      }
    ) {
      subcategory {
        id
      }
    }
  }
`;

export const getSubcategoryListQuery = gql`
  query($referenceId: Int, $categoryId: Int, $subcategoryLevel: Int!) {
    getListOfSubcategories(
      referenceId: $referenceId
      categoryId: $categoryId
      subcategoryLevel: $subcategoryLevel
    ) {
      id
      name
      description
      status
      referenceId
      categoryId {
        id
      }
      viewByAllUsers
      uploadByAllUsers
    }
  }
`;

export const getListOfSubcategoriesforFolderUploadQuery = gql`
  query($referenceId: Int, $categoryId: Int, $subcategoryLevel: Int!) {
    getListOfSubcategoriesforFolderUpload(
      referenceId: $referenceId
      categoryId: $categoryId
      subcategoryLevel: $subcategoryLevel
    ) {
      id
      name
      description
      status
      referenceId
      categoryId {
        id
      }
      viewByAllUsers
      uploadByAllUsers
    }
  }
`;

export const updateSubcategory = gql`
  mutation($id: Int!, $name: String!, $description: String!, $status: Int!) {
    updateSubCategory(
      id: $id
      data: { name: $name, description: $description, status: $status }
    ) {
      message
    }
  }
`;

export const removeSubcategory = gql`
  mutation($id: Int!) {
    deleteSubCategory(id: $id) {
      message
    }
  }
`;

export const getListOfAttachments = gql`
  query($subCategoryId: Int!) {
    getListOfAttachments(subCategoryId: $subCategoryId) {
      id
      status
      name
      tags
      description
      attachmentType
      viewByAllUsers
      url
      gridId {
        id
        name
      }
    }
  }
`;

export const sendEmailForDoc = gql`
  query(
    $attachmentId: String!
    $attachmentName: String!
    $emailUsers: [String!]
  ) {
    sendEmailforDocument(
      attachmentId: $attachmentId
      attachmentName: $attachmentName
      emailUsers: $emailUsers
    )
  }
`;

// export const createSubCatAttachment = gql`
//   mutation($subCategoryId: Int!, $attachmentType: Int!, $gridId: Int!, $data: [CreateSubCatAttachmentInputType]!) {
//     createSubCatAttachment(
//       attachmentType: $attachmentType
//       subCategoryId: $subCategoryId
//       gridId: $gridId
//       data: $data
//       ) {
//         attachment{
//           id
//         }
//     }
//   }
// `;
export const createSubCatAttachment = gql`
  mutation(
    $subCategoryId: Int!
    $attachmentType: Int!
    $gridId: Int!
    $attachmentFile: Upload
  ) {
    createSubCatAttachment(
      attachmentType: $attachmentType
      subCategoryId: $subCategoryId
      gridId: $gridId
      attachmentFile: $attachmentFile
    ) {
      attachment {
        id
      }
    }
  }
`;

export const updateSubCatAttachment = gql`
  mutation(
    $attachmentId: String!
    $sendNotification: Boolean!
    $data: UpdateSubCatAttachmentInputType!
  ) {
    updateSubCatAttachment(
      attachmentId: $attachmentId
      sendNotification: $sendNotification
      data: $data
    ) {
      message
    }
  }
`;

export const getListOfAttachmentUsersByAttachmentId = gql`
  query($attachmentId: String!) {
    getListOfAttachmentUsersByAttachmentId(attachmentId: $attachmentId) {
      id
      userId {
        loginId
      }
      userDetail {
        name
      }
    }
  }
`;

export const addAttachmentUser = gql`
  mutation($userId: [Int]!, $attachmentId: String!) {
    addAttachmentUsers(data: { userId: $userId, attachmentId: $attachmentId }) {
      attachmentusers {
        id
      }
    }
  }
`;

export const removeAttachmentUser = gql`
  mutation($id: String!) {
    removeAttachmentUsers(id: $id) {
      message
    }
  }
`;

export const getListOfAttachmentsByUserId = gql`
  query($tags: String, $offset: Int, $pageNo: Int) {
    getListOfAttachmentsByUserId(
      tags: $tags
      noOfRows: $offset
      pageNumber: $pageNo
    ) {
      id
      categoryStructure
      name
      tags
      description
      attachmentType
      gridId {
        id
        name
      }
    }
  }
`;
export const getListOfAttachmentsByUserIdForFolderQuery=gql`
query($categoryId:Int, $tags: String, $offset: Int, $pageNo: Int) {
  getListOfAttachmentsByUserIdForFolder(
    tags: $tags
    noOfRows: $offset
    pageNumber: $pageNo
    categoryId: $categoryId
  ) {
    id
    categoryStructure
    name
    tags
    description
    attachmentType
    gridId {
      id
      name
    }
  }
}
`;

export const downloadAttachment = gql`
  mutation($attachmentId: String!) {
    downloadSubCatAttachment(attachmentId: $attachmentId) {
      fileData
      fileName
    }
  }
`;

export const ViewSubCatAttachment=gql`
  mutation ViewSubCatAttachment($attachmentId: String!) {
  viewSubCatAttachment(attachmentId: $attachmentId) {
    fileData
    fileName
  }
}
`;

export const downloadBulkSubCatAttachment = gql`
  mutation($subCategoryId: Int!, $attachmentArr: [String]!) {
    downloadBulkSubCatAttachment(
      subCategoryId: $subCategoryId
      attachmentArr: $attachmentArr
    ) {
      fileData
      fileName
    }
  }
`;

export const getListOfAttachmentsForSubcategoryByUserId = gql`
  query($subCategoryId: Int!) {
    getListOfAttachmentsForSubcategoryByUserId(subCategoryId: $subCategoryId) {
      id
      status
      name
      tags
      description
      attachmentType
      viewByAllUsers
      url
      gridId {
        id
        name
      }
    }
  }
`;

export const getListofGenericMasterQueryForView = gql`
  query ($offset: Int, $pageNo: Int, $masterFor: Int!, $descriptionName: String, $status: Int) {
  getListofGenericMaster(NoOfRows: $offset, offset: $pageNo, masterFor: $masterFor, descriptionName: $descriptionName, status: $status) {
    Id
    masterFor
    description
    status
    __typename
  }

  }
`;

export const removeAttachment = gql`
  mutation($attachmentId: String!) {
    removeSubCatAttachment(attachmentId: $attachmentId) {
      message
    }
  }
`;
export const removeSelected=gql`
  mutation($attachmentIds: [String!]!) {
  removeSelectedAttachments(attachmentIds: $attachmentIds) {
    message
  }
}
`;


export const downloadGridById = gql`
  query($gridId: Int!) {
    downloadGridReport(gridId: $gridId)
  }
`;

export const getListOfCategoriesSearchByName = gql`
  query($name: String) {
    getListOfCategoriesSearchByName(name: $name)
  }
`;
export const copyFolderFromSourceToTarget = gql`
  query($sourceCategoryId: Int!, $targetCategoryId: Int!) {
    copyCategorytoCategory(
      sourceCategoryId: $sourceCategoryId
      targetCategoryId: $targetCategoryId
    )
  }
`;

export const getListOfSubcategoriesforFolderViewQuery = gql`
  query($referenceId: Int, $categoryId: Int, $subcategoryLevel: Int!) {
    getListOfSubcategoriesforFolderView(
      referenceId: $referenceId
      categoryId: $categoryId
      subcategoryLevel: $subcategoryLevel
    ) {
      id
      name
      description
      status
      referenceId
      categoryId {
        id
      }
      viewByAllUsers
      uploadByAllUsers
    }
  }
`;

export const addSubCategoryViewUser = gql`
  mutation($userId: [Int]!, $categoryId: Int!, $subcategoryId: Int!) {
    addSubCategoryViewUsers(
      data: {
        userId: $userId
        categoryId: $categoryId
        subcategoryId: $subcategoryId
      }
    ) {
      subcategoryviewusers {
        id
      }
    }
  }
`;

export const addSubCategoryDocUploadUser = gql`
  mutation($userId: [Int]!, $categoryId: Int!, $subcategoryId: Int!) {
    addSubCategoryDocUploadUsers(
      data: {
        userId: $userId
        categoryId: $categoryId
        subcategoryId: $subcategoryId
      }
    ) {
      subcategorydocuploadusers {
        id
      }
    }
  }
`;

export const getListOfSubCategoryViewUserBySubCategoryId = gql`
  query($referenceId: Int!) {
    getListOfSubCategoryViewUsersBySubCategoryId(referenceId: $referenceId) {
      id
      userId {
        loginId
      }
      userDetail {
        name
      }
    }
  }
`;

export const getListOfDocUploadUserBySubCategoryId = gql`
  query($referenceId: Int!) {
    getListOfDocUploadUsersBySubCategoryId(referenceId: $referenceId) {
      id
      userId {
        loginId
      }
      userDetail {
        name
      }
    }
  }
`;
export const updateSubCategoryForFolderView = gql`
  mutation(
    $id: Int!
    $name: String!
    $description: String!
    $status: Int!
    $viewByAllUsers: Boolean!
  ) {
    updateSubCategory(
      id: $id
      data: {
        name: $name
        description: $description
        status: $status
        viewByAllUsers: $viewByAllUsers
      }
    ) {
      message
    }
  }
`;
export const removeSubCategoryViewUser = gql`
  mutation($id: String!) {
    removeSubCategoryViewUsers(id: $id) {
      message
    }
  }
`;

export const removeSubCategoryDocUploadUser = gql`
  mutation($id: String!) {
    removeSubCategoryDocUploadUsers(id: $id) {
      message
    }
  }
`;
export const updateSubCategoryForFolderUpload = gql`
  mutation(
    $id: Int!
    $name: String!
    $description: String!
    $status: Int!
    $uploadByAllUsers: Boolean!
  ) {
    updateSubCategory(
      id: $id
      data: {
        name: $name
        description: $description
        status: $status
        uploadByAllUsers: $uploadByAllUsers
      }
    ) {
      message
    }
  }
`;

export const getListOfSubCategoriesForTreeView = gql`
query ($categoryId: Int!) {
  getListOfSubCategoriesForTreeView(categoryId: $categoryId)
}
`;

export const getCountOfCategories = gql`
  {
    getCountOfCategories
  }
`;

export const getCountOfAttachments = gql`
  {
    getCountOfAttachments
  }
`;

export const getRecentUploadsForDashboard = gql`
  query ($offset: Int) {
    getRecentUploadsForDashboard(noOfRows: $offset)
  }
`;

export const exportProjectsListToCSV = gql`
  {
    exportProjectsListToCSV
  }
`;